/* eslint-disable react/no-unused-prop-types */
// component is extended and props are used in the inherited class but eslint doesn't recognize it
import * as React from 'react';
import { isNil } from 'lodash';

import MentionCardStatusLabels from '../mention-card-status-labels/MentionCardStatusLabels';
import MentionCardMetrics from '../mention-card-metrics/MentionCardMetrics';

import { wrapSearchTermsKeywords } from '../utils/mention-card';

import './mention-card-details.scss';

import type {
  ChannelTypes,
  MentionCardMetrics as MentionCardMetricsType,
  MentionCardModalItem,
  MentionCardViewType
} from 'types';

type Props = {
  post: MentionCardModalItem,
  viewType: MentionCardViewType,
  children: React.ReactNode | undefined | null,
  hideAdditionalStatusLabel?: boolean
};

class MentionCardDetails extends React.PureComponent<Props> {
  renderStatusLabels(matchedSearchTerms: Array<string> | undefined): React.ReactNode {
    const { hideAdditionalStatusLabel } = this.props;
    const updatedMatchedSearchTerms = matchedSearchTerms || [];
    const additionalSearchTermCount = updatedMatchedSearchTerms.length - 1;

    const additionalSearchTerms = wrapSearchTermsKeywords(
      updatedMatchedSearchTerms,
      'mention-card-details__tooltip-overflow'
    );

    return (
      <MentionCardStatusLabels
        matchedSearchTerm={updatedMatchedSearchTerms[0]}
        additionalSearchTerms={additionalSearchTerms}
        additionalSearchTermCount={additionalSearchTermCount}
        hideAdditionalStatusLabel={hideAdditionalStatusLabel}
      />
    );
  }

  renderMetrics(metrics: MentionCardMetricsType, channel: ChannelTypes): React.ReactNode | undefined | null {
    if (isNil(metrics)) {
      return null;
    }

    const { viewType } = this.props;

    return (
      <MentionCardMetrics
        metrics={metrics}
        channel={channel}
        viewType={viewType}
      />
    );
  }
}

export default MentionCardDetails;
